import gettext from '@sdk/lang/gettext';
import { FormLabel } from '@sdk/components/ui/modalForm/modalForm.styles';
import AttachmentsHorizontalPreview from '@sdk/attachments/components/AttachmentsHorizontalPreview';
import { ErrorMessage } from '@hookform/error-message';
import FieldError from '@sdk/components/forms/components/FieldError';

import ClipIcon from '@web/assets/svg/Icons/32/attachment-gray.svg';
import PlusIcon from '@web/assets/svg/Icons/16/note-add.svg';
import { TaskTemplateAddButton } from '@web/shiftTasks/ComposeTask/composeTask.styles';
import { Attachment } from '@web/shiftTasks/types/Attachment';

import {
  AttachmentFieldContainer,
  AttachmentsSeparator,
  AttachmentsPickerContainer,
} from './attachmentsFieldInner.styles';
import { useAttachmentsField } from './attachmentsFieldInner.hooks';

const ATTACHMENTS_LIMIT = 10;

type Props = {
  onChange: (attachments: Attachment[]) => void;
};

export const AttachmentsFieldInner = ({ onChange }: Props) => {
  const { attachmentsState, attachmentsCount, errors, onClick } = useAttachmentsField({ onChange });
  const hasAttachments = attachmentsCount > 0;
  const hasReachedLimit = attachmentsCount >= ATTACHMENTS_LIMIT;

  return (
    <>
      <FormLabel>
        {gettext('attachments')} <ClipIcon aria-hidden={true} />
      </FormLabel>

      <AttachmentsPickerContainer>
        <AttachmentFieldContainer>
          <AttachmentsHorizontalPreview attachmentsState={attachmentsState} />
          {hasAttachments && <AttachmentsSeparator />}
          {!hasReachedLimit && (
            <TaskTemplateAddButton onClick={onClick}>
              <PlusIcon />
              {gettext('Add attachment')}
            </TaskTemplateAddButton>
          )}
        </AttachmentFieldContainer>
        <ErrorMessage
          errors={errors}
          name="attachments"
          render={({ message }) => <FieldError error={message} invalid />}
        />
      </AttachmentsPickerContainer>
    </>
  );
};
